// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SamplePadAgreement: MarkdocTagRegistration = {
  tag: 'sample-pad-agreement',
  component: 'SamplePadAgreement',
};
